import '.em{max-width:360px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.k{padding:24px;}.ssr-plugin'
import '.en{gap:0px;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.eo{top:116px;}.ssr-plugin'
import '.ep{z-index:1;}.ssr-plugin'
import '.eq{margin-bottom:6px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { useRef, useEffect } from 'react'
import { colors } from '../utils/colors.js'
import { Note } from './Note.js'
import { Button } from './Button.js'
import { Icon } from '../assets/icons/index.js'
import { useLanguage } from '../hooks/useLanguage.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MENU_IN_FROM_TOP } from '../utils/animations.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { interpolate } from '../utils/interpolate.js'

// esbuild constant-folds `${id}-suffix` in JSX into a string literal
// from one call site, breaking other call sites' derived IDs.
// A separate function prevents the optimizer from inlining across call sites.
const deriveId = (base: string | undefined, suffix: string) =>
  base ? base + '-' + suffix : undefined

export const MenuVotingRegion = ({
  setOpen,
  setOpenLangSelectModal,
  setOpenRegionModal,
  id = 'menu-button',
  triggerId = 'menu-button',
  style,
  animation = MENU_IN_FROM_TOP,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const langModalId = deriveId(id, 'action-open-languagemodal')
  const regionModalId = deriveId(id, 'action-open-regionmodal')

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if ((e.target as HTMLElement).id === triggerId) {
        e.preventDefault()
      } else if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [setOpen])

  const [lang] = useLanguage()
  const [votingRegion] = useVotingRegion()
  const votingRegionName = useVotingRegionName(votingRegion?.code)

  const {
    localizationTitle,
    notAllowedToVote,
    onlyCallVotingSupported,
    onlySMSVotingSupported,
    cardLocationNotice,
  } = useDictionary()

  return (
    <styled.div className="blur em a o p k en cq a6 eo ep"
      ref={ref}
      style={{
        border: `1px solid ${colors.border}`,
        backgroundColor: transparentColor(colors.secondary, 0.66),
        animation,
        ...style,
      }}
    >
      <p className="subtext eq ca"
      >
        {localizationTitle}
      </p>
      <Button
        fullWidth
        id={langModalId}
        variant="ghost"
        leadIcon={<Icon type="languageIcon" />}
        trailIcon={<Icon type="chevronRightIcon" />}
        style={{ marginLeft: '-16px', marginRight: '-16px', width: 'auto' }}
        onClick={() => {
          setOpenLangSelectModal(true)
          setOpen(false)
        }}
      >
        {lang?.name}
      </Button>
      <Button
        fullWidth
        id={regionModalId}
        variant="ghost"
        leadIcon={<Icon type="locationIcon" />}
        trailIcon={<Icon type="chevronRightIcon" />}
        style={{
          marginLeft: '-16px',
          marginRight: '-16px',
          marginBottom: 8,
          width: 'auto',
        }}
        onClick={() => {
          setOpenRegionModal(true)
          setOpen(false)
        }}
      >
        {votingRegionName}
      </Button>
      <Note
        color="orange"
        style={{ '& p': { fontSize: '14px', textAlign: 'left' } }}
      >
        {votingRegion?.code === 'SM'
          ? interpolate(notAllowedToVote, { votingRegionName })
          : votingRegion?.voteType === 'call_suffix'
            ? onlyCallVotingSupported
            : votingRegion?.voteType === 'sms_text' ||
                votingRegion?.voteType === 'sms_suffix'
              ? onlySMSVotingSupported
              : interpolate(cardLocationNotice, {
                  votingRegionName,
                })}
      </Note>
    </styled.div>
  )
}
